import React from 'react';

import FsIconButton from '~/components/core/FsWrappers/FsIconButton/FsIconButton';
import ExpandIcon from '~/components/icons/ExpandIcon';
import MinimizeIcon from '~/components/icons/MinimizeIcon';

import { TEXTS } from './texts';

/**
 * The preview's height in a full-screen dialog, merged over its default. The 216px is measured in the browser: the
 * tallest frame either dialog keeps on screen around the preview, so the preview dialog does not scroll and the
 * review's preview fits its visible area. Re-measure when a dialog's title, footer or padding changes.
 */
export const FULL_SCREEN_PREVIEW_CLASS_NAME = 'h-[calc(100vh-216px)]';

/** A dialog's full-screen state, starting at its normal size. */
export const useFullScreenToggle = () => {
  const [isFullScreen, setIsFullScreen] = React.useState(false);

  return {
    isFullScreen,
    toggleFullScreen: () => setIsFullScreen((current) => !current),
  };
};

interface FullScreenToggleButtonProps {
  isFullScreen: boolean;
  onClick: () => void;
}

/** The button that switches a dialog's full-screen state; goes in its title bar, `CardDialog`'s `action`. */
export const FullScreenToggleButton: React.FC<FullScreenToggleButtonProps> = ({ isFullScreen, onClick }) => {
  const label = isFullScreen ? TEXTS.EXIT_FULL_SCREEN : TEXTS.FULL_SCREEN;

  return (
    <FsIconButton
      icon={isFullScreen ? MinimizeIcon : ExpandIcon}
      tooltipText={label}
      aria-label={label}
      onClick={onClick}
      ignorePermissions
    />
  );
};
